"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Document = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Document = function Document() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 2H11.24C10.4446 2.0007 9.68207 2.31723 9.12 2.88L4.88 7.12C4.31723 7.68207 4.0007 8.44462 4 9.24V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM18 20H6V10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9V4H18V20ZM8 12.5V13.5C8 13.6326 8.05268 13.7598 8.14645 13.8536C8.24021 13.9473 8.36739 14 8.5 14H15.5C15.6326 14 15.7598 13.9473 15.8536 13.8536C15.9473 13.7598 16 13.6326 16 13.5V12.5C16 12.3674 15.9473 12.2402 15.8536 12.1464C15.7598 12.0527 15.6326 12 15.5 12H8.5C8.36739 12 8.24021 12.0527 8.14645 12.1464C8.05268 12.2402 8 12.3674 8 12.5ZM12.5 16H8.5C8.36739 16 8.24021 16.0527 8.14645 16.1464C8.05268 16.2402 8 16.3674 8 16.5V17.5C8 17.6326 8.05268 17.7598 8.14645 17.8536C8.24021 17.9473 8.36739 18 8.5 18H12.5C12.6326 18 12.7598 17.9473 12.8536 17.8536C12.9473 17.7598 13 17.6326 13 17.5V16.5C13 16.3674 12.9473 16.2402 12.8536 16.1464C12.7598 16.0527 12.6326 16 12.5 16Z",
    clipRule: "evenodd"
  });
};

exports.Document = Document;